module.exports = __webpack_public_path__ + "img/shopping-cart.6f6290ac.svg";